export default function SpeakerEach({ speaker, handleSpeaker }) {
  const speakerFunct = (change, value) => {
    let speakerCopy = speaker;
    speakerCopy[change] = value

    handleSpeaker(speakerCopy)
  };

  return (
    <section className="speaker--each">
      <h4>{speaker.name}</h4>
      <img src={speaker.image} alt="speaker" />
      <select onChange={(e) => speakerFunct("vote", e.target.value)}>
        <option>-- Please Vote --</option>
        <option>1</option>
        <option>2</option>
        <option>3</option>
        <option>4</option>
        <option>5</option>
      </select>
      <textarea type="text" rows="5" cols="20" onChange={(e) => speakerFunct("comment", e.target.value)}/>
    </section>
  );
}
